import { AxiosError } from 'axios';

import { ToastProps } from '@core/components/Toast/components/ToastComponent';

export function mapNetworkError(error: AxiosError | Error | unknown) {
  if (error instanceof AxiosError) {
    return {
      message: error.response?.data?.error || error.message,
      status: error.response?.status,
    };
  }
  return {
    message: error instanceof Error ? error.message : 'An unexpected error occurred',
    status: 500,
  };
}

export function handleNetworkError(
  error: AxiosError | Error,
  showToast: (toast: Omit<ToastProps, 'id'>) => void
) {
  const { message } = mapNetworkError(error);
  showToast({
    title: 'Error',
    description: message,
    variant: 'destructive',
  });
}

export const devMode = import.meta.env.VITE_ENVIRONMENT === 'development';
